import React from 'react';
import type { PlayerMood } from '../types';

interface PlayerAvatarProps {
  mood: PlayerMood;
  characterImage?: string;
  characterName?: string;
  characterReactions?: {
    idle: string;
    happy: string;
    sad: string;
  };
}

const PlayerAvatar: React.FC<PlayerAvatarProps> = ({
  mood,
  characterImage,
  characterName,
  characterReactions,
}) => {
  const moodImage = characterReactions?.[mood] ?? characterImage;

  return (
    <div className="flex flex-col items-center gap-1.5">
      {moodImage ? (
        <img
          src={moodImage}
          alt={characterName ?? 'Player'}
          className="w-auto object-contain drop-shadow-lg transition-all duration-300 h-[clamp(90px,18vh,160px)] sm:h-[clamp(140px,35vh,370px)]"
        />
      ) : (
        <div className="w-14 h-14 sm:w-20 sm:h-20 rounded-full bg-amber-400 border-2 shadow-lg flex items-center justify-center">
          <span className="text-2xl sm:text-3xl select-none"></span>
        </div>
      )}
      <span
        className="px-3 py-1 rounded-full text-xs sm:text-sm font-caudex text-white whitespace-nowrap"
        style={{
          background: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(4px)',
          border: '1px solid rgba(255,255,255,0.25)',
        }}
      >
        You
      </span>
    </div>
  );
};

export default PlayerAvatar;